import { render, staticRenderFns } from "./resourcesAccessForm.vue?vue&type=template&id=a67771d2"
import script from "./resourcesAccessForm.vue?vue&type=script&lang=js"
export * from "./resourcesAccessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports